export const RELEASE_MODULE = {
  ITEM_VIEW: 'item-view',
} as const;

export type ReleaseModule =
  (typeof RELEASE_MODULE)[keyof typeof RELEASE_MODULE];

export interface ReleaseVersion {
  releasedAt: string;
  updatesUrl?: string;
  announcements: ReleaseAnnouncement[];
}

export interface ReleaseAnnouncement {
  id: string;
  title: string;
  description: string;
  videoUrl: string;
  modules: ReleaseModule[];
  badgeLabel?: string;
  priority?: number;
}

export interface ReleaseAnnouncementSlide extends ReleaseAnnouncement {
  releaseVersion: number;
  releasedAt: string;
  updatesUrl: string;
}

export const RELEASE_UPDATES_URL = 'https://getsign.io';

/**
 * How to add an item-view release announcement:
 *
 * 1. Add a new object to `releaseVersions`.
 * 2. Set `releasedAt` to the release date. The app derives the release version
 *    from this value, so do not add a manual version field.
 *    - Use `YYYY-MM-DD` for one release per day.
 *    - Use `YYYY-MM-DDTHH:mm:00Z` if multiple releases happen on the same day.
 * 3. Add one or more announcement slides under `announcements`.
 * 4. Keep every slide `id` unique. Duplicate IDs can make carousel batch
 *    tracking/debugging ambiguous because the UI keys slides by id + version.
 * 5. Use Loom embed URLs for videos, not Loom share URLs:
 *    `https://www.loom.com/embed/<video-id>`.
 *
 * Available modules:
 * - RELEASE_MODULE.ITEM_VIEW
 *
 * Copy/paste template:
 *
 * {
 *   releasedAt: '2026-05-01',
 *   announcements: [
 *     {
 *       id: 'unique-release-slide-id',
 *       title: 'Feature title',
 *       description: 'Short user-facing description of what changed.',
 *       videoUrl: 'https://www.loom.com/embed/your-video-id',
 *       modules: [RELEASE_MODULE.ITEM_VIEW],
 *       badgeLabel: "WHAT'S NEW IN GETSIGN",
 *       priority: 10,
 *     },
 *   ],
 * },
 */
export const releaseVersions: ReleaseVersion[] = [
  // Sign anywhere
  // {
  //   releasedAt: '2026-05-13',
  //   announcements: [
  //     {
  //       id: 'sign-anywhere-multiple-signers',
  //       title: 'Sign anywhere with multiple signers',
  //       description:
  //         'Send documents for e-signature without placing signature pads on the PDF. Add multiple signers to one envelope and let each person complete their signature in the usual signing flow.',
  //       videoUrl: '',
  //       modules: [RELEASE_MODULE.ITEM_VIEW],
  //       badgeLabel: "WHAT'S NEW IN GETSIGN",
  //       priority: 10,
  //     },
  //   ],
  // },
];
